//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import processLogTime from './process-log-time.vue';
import { processRunStatus } from '../common';
import { mapGetters, mapActions } from 'vuex';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import _ from 'lodash';
dayjs.locale('zh-cn');
dayjs.extend(relativeTime);
dayjs.extend(LocalizedFormat);
export default {
  name: '',
  components: { processLogTime },
  props: {
    innerComponent: {
      type: Boolean,
      default: false,
    },
    processInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      row: {},
      logTimeLine: 30,
      visible: false,
      detailVisiable: false,
      search: {
        param: '',
        status: '',
        module: '',
        biz_type: '',
        triggerTime: [],
        endTime: [],
      },
      originSearch: {},
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableLoading: false,
      processRunStatus,
      detailRow: {},
      detailLoading: false,
      logs: [],
    };
  },
  async created() {
    let rowInfo;
    if (!this.innerComponent) {
      this.$store.commit('user/setBreadcrumb', [
        { title: '流程管理', path: '/approval-process/process-manage' },
        { title: '流程日志', path: '/workflow/process-log' },
      ]);
      rowInfo = JSON.parse(this.$route.query.row);
    } else {
      rowInfo = this.processInfo;
    }
    this.row = {
      ...rowInfo,
      title: `${rowInfo.process_name} | ${rowInfo.version}`,
    };
    await this.requestBusinessOptionList();
  },
  mounted() {
    this.getProcessLogConfigure();
    this.reset();
  },
  methods: {
    ...mapActions({
      requestBusinessOptionList: 'workflow/requestBusinessOptionList',
    }),
    openTimeDia() {
      this.visible = true;
    },
    checkDetail(row) {
      this.detailRow = row;
      if (row.id) {
        this.detailVisiable = true;
        this.getProcessInstanceLog(row.id);
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.originSearch = _.cloneDeep(this.search);
      this.getList();
    },
    async getList() {
      try {
        this.tableLoading = true;
        const { data = [], total = 0 } = await this.$request({
          url: this.$api.getProcessInstanceList,
          data: {
            input_params: {
              start: `${(this.currentPage - 1) * this.pageSize}`,
              size: `${this.pageSize}`,
              param: this.originSearch.param,
              status: this.originSearch.status,
              module: this.originSearch.module,
              biz_type: this.originSearch.biz_type,
              process_define_id: this.row.process_id,
            },
            start_trigger_time: this.originSearch.triggerTime[0],
            end_trigger_time: this.originSearch.triggerTime[1],
            start_finish_time: this.originSearch.endTime[0],
            end_finish_time: this.originSearch.endTime[1],
          },
          showLoading: false,
        });
        this.tableData = data.map((item) => {
          return {
            ...item,
            biz_type: this.generateBizType(item.biz_type),
            module: this.generateModule(item.module),
          };
        });
        this.total = total;
        this.tableLoading = false;
      } catch (err) {
        console.log(err);
        this.tableLoading = false;
      }
    },
    async getProcessInstanceLog(id) {
      try {
        this.detailLoading = true;
        this.logs = [];
        const { logs } = await this.$request({
          url: this.$api.getProcessInstanceLog,
          data: {
            process_instance_id: id,
          },
          showLoading: false,
        });
        this.logs = logs;
        this.detailLoading = false;
      } catch (err) {
        console.error('errrr=', err);
        this.detailLoading = false;
      }
    },
    getProcessLogConfigure() {
      console.log('this.row', this.row);
      this.$request({
        url: this.$api.getProcessLogConfigure,
        data: {
          process_key: this.row.process_key,
        },
      }).then((res) => {
        if (typeof +res.log_clear_day === 'number') {
          this.logTimeLine = +res.log_clear_day;
        }
      });
    },
    setProcessLogConfigure(day) {
      this.$request({
        url: this.$api.setProcessLogConfigure,
        data: {
          process_key: this.row.process_key,
          log_clear_day: +day,
        },
      }).then(() => {
        this.getProcessLogConfigure();
      });
    },
    reset() {
      this.search.param = '';
      this.search.status = '';
      this.search.module = '';
      this.search.biz_type = '';
      this.search.triggerTime = [];
      this.search.endTime = [];
      this.currentPage = 1;
      this.pageSize = 10;
      this.originSearch = _.cloneDeep(this.search);
      this.getList();
    },
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    formatTime(val) {
      if (!val) return '-';
      return dayjs(val).format('YYYY-MM-DD HH:mm:ss');
    },
    generateModule(val) {
      if (!val) return '';
      return this.businessModuleList.find((item) => item.value === val)?.label || '';
    },
    generateBizType(val) {
      if (!val) return '';
      return this.businessTypeList.find((item) => item.value === val)?.label || '';
    },
  },
  computed: {
    ...mapGetters({
      businessTypeList: 'workflow/getBusinessTypeList',
      businessModuleList: 'workflow/getBusinessModuleList',
    }),
    detailTitle() {
      return `【${this.detailRow.module ? `${this.detailRow.module}-` : ''}${
        this.detailRow.biz_type ?? ''
      }】详情`;
    },
  },
};
